<script>

import {defineComponent} from "vue";
import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch.vue";
import {OpsPath, StorePath} from "@/path";
import axios from "axios";

export default defineComponent({
  props : ['op'],
  computed: {
    StorePath() {
      return StorePath
    }
  },
  components: {SelectWithSearch},
  data(){
    return {
      errors : [],
      store : null,
      base_url : process.env.VUE_APP_API_BACKEND_URL
    }
  },
  methods :{
    async uploadToUp(){
      if(!this.store){
        this.errors.push('store');
        return;
      }
      try{
        let res = await axios.post(this.base_url + OpsPath.OP_PUSH_TO_UP,{
          store_id : this.store,
          op : this.op
        });
        if(res.data.status){
          this.$bvToast.toast('Successfully updated', {
            title: `Modifier updated to urban piper`,
            variant: 'success',
            solid: true
          });
          this.$bvModal.hide("bv-upload-opg");
        }else{
          this.$bvToast.toast('Failed to updated', {
            title: `Modifier Failed to upload to urban piper`,
            variant: 'error',
            solid: true
          });
        }
      }catch (e) {
        console.log(e);
      }
    }
  }
})
</script>

<template>
  <div class="row">
    <div class="col-sm-12 col-md-12">
      <b-container fluid>
        <b-row class="my-1">
          <b-col sm="12">
            <label>Store:</label>
          </b-col>
          <b-col sm="12">
            <SelectWithSearch @selectedOption="((v) => this.store = v)" :search_api="StorePath.SEARCH_STORE" track_by="id" display="name" :merge_display="['restaurant.name','brand.name']"></SelectWithSearch>
          </b-col>
          <b-col sm="12">
            <b-button variant="primary" @click="uploadToUp">Upload to urban piper</b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<style scoped>

</style>